module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-select"
  }, [_c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "focus": _vm.onInputFocus,
      "blur": _vm.onInputBlur,
      "keydown": _vm.onKeyDown,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.placeholder) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.searchText),
      expression: "!searchText"
    }],
    staticClass: "placeholder"
  }, [_vm._v("\n            " + _vm._s(_vm.placeholder) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdownOpen),
      expression: "dropdownOpen"
    }],
    ref: "dropdown",
    staticClass: "dropdown"
  }, [_c('ul', {
    staticClass: "option-list"
  }, _vm._l((_vm.filteredOptions), function(option) {
    return _c('li', {
      key: option.value,
      class: _vm.getOptionClasses(option),
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
        },
        "mouseenter": function($event) {
          _vm.highlightOption(option)
        },
        "click": function($event) {
          _vm.selectOption(option)
        }
      }
    }, [_vm._v("\n                " + _vm._s(option.label) + "\n            ")])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.optionsLoading),
      expression: "optionsLoading"
    }],
    staticClass: "status-msg"
  }, [_vm._v("\n            Loading...\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.optionsLoading && _vm.options.length === 0),
      expression: "!optionsLoading && options.length === 0"
    }],
    staticClass: "status-msg"
  }, [_vm._v("\n            No results\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-275b16ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/search-select/index.vue
// module id = 1976
// module chunks = 2